import { Helmet } from "react-helmet";
import { FiExternalLink, FiShoppingCart } from "react-icons/fi";
import heroImage from "../img/New/designpackhero2.png";
import "./DesignHeroPremium.css";
import CustomModal from "./Modal";
import { useState } from "react";

const DesignHeader = () => {
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <Helmet>
        <title>
          Design Packages for Branding & Social Media | Oglitz Software
        </title>
        <meta
          name="description"
          content="Explore premium design packages by Oglitz Software. Social media design, branding kits, and creative services crafted to grow your business visibility and brand trust."
        />
        <meta
          name="keywords"
          content="design packages, social media design, branding services, graphic design packages, Oglitz Software"
        />
      </Helmet>

      <section className="oglitz-design-hero-split">
        <div className="oglitz-design-hero-split__container">
          {/* LEFT CONTENT */}
          <div className="oglitz-design-hero-split__content">
            <span className="oglitz-design-hero-split__badge">
              Premium Design Services
            </span>

            <h1 className="oglitz-design-hero-split__title">
              Professional{" "}
              <span className="oglitz-design-hero-split__title-accent">
                Design Packages
              </span>
              <br /> for Growing Brands
            </h1>

            <p className="oglitz-design-hero-split__subtitle">
              High-impact{" "}
              <strong>branding and social media design packages </strong>
              built to strengthen your visual identity, improve engagement, and
              establish long-term brand credibility. Trusted by startups and
              growing businesses.
            </p>

            <div className="oglitz-design-hero-split__actions">
              <a
                href="#design-packages"
                className="oglitz-design-hero-split__primary-btn"
              >
                Explore Packages
              </a>

              <a
                href="/contact"
                className="oglitz-design-hero-split__secondary-btn"
              >
                Talk to Expert
              </a>
            </div>
          </div>

          {/* RIGHT DEMO CARD */}
          <div className="oglitz-design-hero-split__visual">
            <div className="oglitz-design-hero-demo-card">
              <div className="oglitz-design-hero-demo-card__image-wrap">
                <img
                  src={heroImage}
                  alt="Social Media Design Package Demo"
                  className="oglitz-design-hero-demo-card__image"
                />
              </div>

              <div className="oglitz-design-hero-demo-card__content">
                <h4 className="oglitz-design-hero-demo-card__title">
                  Social Media Design Package
                </h4>

                <div className="oglitz-design-hero-demo-card__actions">
                  {/* Icon-only – Details */}
                  <a
                    href="#design-packages"
                    className="oglitz-design-hero-demo-card__icon-btn"
                    aria-label="View More Details"
                  >
                    <FiExternalLink />
                  </a>

                  {/* Primary CTA */}
                  <a
                    onClick={() => setModalShow(true)}
                    style={{cursor:"pointer"}}
                    className="oglitz-design-hero-demo-card__order-btn"
                  >
                    <FiShoppingCart />
                    Order Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CustomModal
          isOpen={modalShow}
          onRequestClose={() => setModalShow(false)}
          modalData={[]}
        />
      </section>
    </>
  );
};

export default DesignHeader;
